import React from "react"
import {FieldInlineEditableProps} from "../../../render/inline-editable";
import {FieldViewSize} from "../../../const";

const debug = false
// const debug = "FieldPopover_GlistEditable"

type State = {
    initialPropsValue   : any, // required to check if currentOption update needed on props changed
    currentValue        : any,
    showPopover         : boolean
}

export default class FieldPopover_GlistEditable extends React.Component<FieldInlineEditableProps,State> {

    public previousValue        : any

    public static defaultProps  = {
        size        : FieldViewSize.DEFAULT
    }

    constructor(props:FieldInlineEditableProps) {
        super(props);

        const value = props.field.getViewValue(props.model)

        debug && console.log(debug,"constructor initValue=", value)

        this.state = {
            initialPropsValue   : value, // required to check if currentValue update needed on props changed
            currentValue        : value,
            showPopover         : false,
        }
    }

    static getDerivedStateFromProps(props:any, state:any) {

        const value = props.model[props.field.fieldId]

        if (value !== state.initialPropsValue) {
            return {
                initialPropsValue   : value,
                currentValue        : value
            }
        }

        return null // no changes
    }

    showPopover = (e?:React.SyntheticEvent) => {
        e?.stopPropagation()
        if (!this.state.showPopover) this.setState({showPopover: true})
    }

    public hidePopover = () => {
        if (this.state.showPopover) this.setState({showPopover: false})
    }


    onValueChange = (value:any, hidePopover: boolean = true) => {

        debug && console.log(debug, "onValueChange", value)

        this.previousValue  = this.state.currentValue;
        const newValue      = value; //_.get(option, 'value', null);

        this.setState({
            currentValue: newValue
        }, () => {
            if (this.props.onChange) this.props.onChange(newValue, this.onCancelChange);
            if (hidePopover) this.hidePopover()
        });
    }

    onCancelChange = () => {
        this.setState({
            currentValue: this.previousValue
        });
    }

    render() {

        debug && console.log(debug, "render()", this.state, this.props.field)

        const {field} = this.props;

        const classes = Classes("ui5-txt-less-important-small", this.props.className, {
            'show-popover' : this.state.showPopover,
        });


        // need check value because of none
        if (this.state.currentValue && (!Array.isArray(this.state.currentValue) || !_.isEmpty(this.state.currentValue))) {
            return (
                <field.components.InlineValueNotEmpty className={classes}
                                                      field={this.props.field}
                                                      size={this.props.size}
                                                      value={this.state.currentValue}
                                                      configOptions={this.props.configOptions}
                                                      onClick={this.showPopover}
                                                      onChange={this.onValueChange}>
                    {this.state.showPopover && <field.components.PopoverMenu {...this.props} parent={this} value={this.state.currentValue} />}
                </field.components.InlineValueNotEmpty>
            );
        } else {
            return (
                <field.components.InlineValueEmpty className={classes}
                                                   field={this.props.field}
                                                   size={this.props.size}
                                                   configOptions={this.props.configOptions}
                                                   onClick={this.showPopover}>
                    {this.state.showPopover && <field.components.PopoverMenu {...this.props} parent={this} />}
                </field.components.InlineValueEmpty>
            );
        }
    }
}
